<template>
  <div class="mx-5">
    <div v-if="instructor">
      <ProfileContainer
        :name="`${instructor.firstName} ${instructor.lastName}`"
        :phone="instructor.phone"
        :email="instructor.email"
      >
        <div class="instructor-card">
          <img
            :src="profilePicPath"
            alt="Profile Picture"
            width="150"
            height="150"
          />
          <div class="instructor-info">
            <div class="d-flex justify-content-between">
              <div>
                <span class="border-info">{{ instructor.role }}</span>
                <span class="">CFII</span>
                <h1 class="instructor-name m-0">
                  {{ `${instructor.firstName} ${instructor.lastName}` }}
                </h1>
                <span class="border-info">{{
                  formatPhoneNumber(instructor.phone)
                }}</span>
                <span class="">{{ instructor.email }}</span>
              </div>
            </div>
            <div class="buttons d-flex mt-2">
              <button class="btn mr-2" @click="goToDocuments">
                Class Documents
              </button>
              <!-- <button class="btn mr-2">Endorsements</button> -->
              <hilo-button
                class="btn mr-2"
                label="Logbook"
                @click="goToLogbook"
              />
              <!-- <button class="btn btn-green">$0.00</button> -->
            </div>
          </div>
        </div>

        <div class="cards-container mt-5">
          <!-- First card -->
          <div class="profile-card">
            <div class="d-flex justify-content-between">
              <span style="font-size: 25px">Current Class</span>
              <div class="d-flex align-items-start">
                <span class="average-grade">{{ averageGrade }}%</span>

                <img class="dots" src="/static/img/dotted.svg" alt="dots" />
              </div>
            </div>

            <div
              class="d-flex justify-content-between align-items-end"
              v-if="
                currentClass.name &&
                currentClass.startDate &&
                currentClass.endDate
              "
            >
              <h3 class="role">{{ currentClass.name }} Pilot</h3>
              <!-- <span class="grade-banner">{{ currentClass }}</span> -->
            </div>

            <div class="d-flex align-items-center">
              <img
                src="https://placehold.co/16x16"
                alt="Placeholder"
                class="mr-2"
              />
              <p class="m-0">{{ instructor.flightSchool }}</p>
            </div>

            <div class="d-flex">
              <p class="border-info mb-2">
                Start Date: {{ currentClass.startDate }}
              </p>
              <p class="mb-2">End Date: {{ currentClass.endDate }}</p>
            </div>

            <div class="buttons d-flex">
              <button class="btn mr-2">Grade Book</button>
              <hilo-button
                class="btn mr-2"
                style="margin-right: 20px"
                label="Logbook"
                @click="goToLogbook"
              />
            </div>
            <div class="progress mt-2">
              <div
                class="progress-bar"
                role="progressbar"
                :style="{ width: `${calculateDaysLeft()}%` }"
                :aria-valuenow="calculateDaysLeft()"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <p class="m-0">{{ calculateDaysLeft() }}/43 Days</p>
              </div>
            </div>
            <!-- <p class="m-0">Total Days: {{ calculateDaysTotal() }}</p>
            <p class="m-0">Days Left: {{ calculateDaysLeft() }}</p> -->
          </div>

          <!-- Second card -->
          <!-- <div class="profile-card">
            <div class="d-flex justify-content-between">
              <span>Last Session</span>
              <div class="d-flex align-items-start">
                <img class="dots" src="/static/img/dotted.svg" alt="dots" />
              </div>
            </div>
            <h3>Flight 7</h3>
            <p>Monday, December 27th, 2024 at 7:00 am</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor magna aliquaincididunt ut
              labore et dolore magna aliqua. Ut enim ad minim sed do veniam, quis nostrud exercitation ullamco laboris
              sed do nisiantus. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor magna
              aliquaincididunt ut labore et dolore magna aliqua. Ut enim ad minim sed do veniam, quis nostrud
              exercitation ullamco laboris sed do nisiantus</p>
            <div class="buttons d-flex">
              <button class="btn mr-2">View Flight</button>
              <button class="btn mr-2">Edit</button>
            </div>
          </div> -->

          <!-- <div class="profile-card" v-if="lastFlightSession">
            <div class="d-flex justify-content-between">
              <span>Last Session</span>
            </div>
            <div class="d-flex align-items-start">
              <img class="dots" src="/static/img/dotted.svg" alt="dots" />
            </div>
            <h3>{{ lastFlightSession.name }}</h3>
            <p>{{ lastFlightSession.date }}</p>
            <p>{{ lastFlightSession.description }}</p>
            <div class="buttons d-flex">
              <button class="btn mr-2">View Flight</button>
              <button class="btn mr-2">Edit</button>
            </div>
          </div> -->

          <!-- Third card -->
          <!-- <div class="profile-card">
            <div class="d-flex justify-content-between">
              <span>Next Session</span>
              <div class="d-flex align-items-start">
                <img class="dots" src="/static/img/dotted.svg" alt="dots" />
              </div>
            </div>
            <h3>Flight 8</h3>
            <p>Monday, December 27th, 2024 at 7:00 am</p>
            <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor magna aliquaincididunt ut
              labore et dolore magna aliqua. Ut enim ad minim sed do veniam, quis nostrud exercitation ullamco laboris
              sed do nisiantus. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor magna
              aliquaincididunt ut labore et dolore magna aliqua. Ut enim ad minim sed do veniam, quis nostrud
              exercitation ullamco laboris sed do nisiantus</p>
            <div class="buttons d-flex">
              <button class="btn mr-2">View Flight</button>
              <button class="btn mr-2">Edit</button>
            </div>
          </div> -->

          <!-- Fourth card -->
          <div class="d-flex flex-column">
            <div class="payroll profile-card">
              <h4 class="m-0">
                Payroll
                <span>{{
                  instructor.payRate?.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                }}</span>
              </h4>
              <p class="m-0">
                Next Payday: {{ payroll.paymentDate.toLocaleDateString() }}
              </p>
            </div>

            <!-- Seventh card -->
            <div class="hours-card profile-card">
              <h4 class="m-0">Submit Hours</h4>
              <p class="m-0">
                Period: {{ payroll.periodStart.toLocaleDateString() }} -
                {{ payroll.periodEnd.toLocaleDateString() }}
              </p>
            </div>
          </div>

          <!-- Fifth card -->
          <!-- <div class="profile-card">
            <div class="d-flex justify-content-between">
              <span>Next Checkride</span>
              <div class="d-flex align-items-start">
                <img class="dots" src="/static/img/dotted.svg" alt="dots" />
              </div>
            </div>
            <h3>Tyler Johnson</h3>
            <p>Monday, December 27th, 2024 at 7:00 am</p>
            <div class="buttons d-flex">
              <button class="btn mr-2">View Flight</button>
              <button class="btn mr-2">Edit</button>
            </div>
          </div> -->

          <!-- Sixth card -->
          <!-- <div class="profile-card">
            <div class="d-flex justify-content-between">
              <span>Next Checkride</span>
              <div class="d-flex align-items-start">
                <img class="dots" src="/static/img/dotted.svg" alt="dots" />
              </div>
            </div>
            <h3>Tyler Johnson</h3>
            <p>Monday, December 27th, 2024 at 7:00 am</p>
            <div class="buttons d-flex">
              <button class="btn mr-2">View Flight</button>
              <button class="btn mr-2">Edit</button>
            </div>
          </div> -->

          <!-- End cards -->
        </div>

        <!-- Schedule -->
        <div class="d-flex justify-content-between mt-5 mb-2">
          <div class="d-flex align-items-center pl-4">
            <img
              src="https://placehold.co/27x27"
              alt="Placeholder"
              class="mr-2"
            />
            <p class="m-0 font-weight-bold">{{ instructor.flightSchool }}</p>
          </div>
          <div class="buttons d-flex">
            <!-- <button class="btn mr-2">View Full Schedule</button> -->
            <router-link to="/hilo/schedule" custom v-slot="{ navigate }">
              <hilo-button
                label="View Full Schedule"
                class="btn mr-2"
                @click="navigate"
              />
            </router-link>
            <!-- <button class="btn mr-2">Add to Google</button> -->
          </div>
        </div>

        <div class="d-flex schedule">
          <h1 class="m-0">Schedule</h1>
          <ScheduleCards />
        </div>

        <!-- All Students -->
        <div class="mt-5">
          <HiloTable
            :columns="hiloTableColumns"
            :data="filteredStudents"
            variation="unstyled"
          >
          </HiloTable>
        </div>
      </ProfileContainer>
    </div>
  </div>
</template>
<script>
import ProfileContainer from "../../../components/HiloComponents/ProfileContainer.vue";
import HiloButton from "../../../components/HiloComponents/HiloButton.vue";
import HiloTable from "../../../components/HiloComponents/HiloTable.vue";
import ScheduleCards from "./ScheduleCards.vue";

import { useLoginStore } from "@/stores/loginStore";
import dayjs from "dayjs";

import ActiveInstructorsAPIService from "src/servicehandlers/ActiveInstructorsAPIService";
import ActiveStudentsAPIService from "src/servicehandlers/ActiveStudentsAPIService";
import ClassesAPIService from "../../../servicehandlers/ClassesAPIService";
import FlightSchoolsAPIService from "src/servicehandlers/FlightSchoolsAPIService";

const activeInstructorsAPIService = new ActiveInstructorsAPIService();
const activeStudentsAPIService = new ActiveStudentsAPIService();
const classesAPIService = new ClassesAPIService();
const flightSchoolsAPIService = new FlightSchoolsAPIService();

export default {
  components: {
    ScheduleCards,
    HiloTable,
    HiloButton,
    ProfileContainer,
  },
  data() {
    return {
      instructor: null,
      profilePicPath: null,
      currentClass: null,
      payroll: null,
      allStudents: [],
      filteredStudents: [],
      hiloTableColumns: [],
      averageGrade: 0,
    };
  },
  async mounted() {
    try {
      await this.getClass();
      this.setupTableColumns();
      this.getPayroll();
      await this.getInstructor();
      await this.fetchStudents();
      await this.fetchAndCalculateAverage();
    } catch (error) {}
  },
  methods: {
    // Navigation Methods
    navigateToStudentProfile(studentId) {
      this.$router.push({ name: "Profile Student", params: { id: studentId } });
    },
    goToLogbook() {
      this.$router.push({ name: "Logbook" });
      alert(`Going to logbook page with user id ${this.instructor.user.id}`);
    },
    goToDocuments() {
      this.$router.push({
        name: "Documents",
        params: { userId: this.instructor?.userId || "" },
      });
    },

    // Data Fetching Methods
    async getClass() {
      try {
        let response;
        if (this.$route.params.id) {
          response = await classesAPIService.getByInstructorId(
            this.$route.params.id,
          );
        } else {
          const store = useLoginStore();
          const user = store.getUser;
          response = await classesAPIService.getByInstructorUserId(user.id);
        }

        const startDate = response.startDate
          ? dayjs(response.startDate).format("MM/DD/YYYY")
          : "";
        const endDate = response.endDate
          ? dayjs(response.endDate).format("MM/DD/YYYY")
          : "";

        const students = response?.studentToClassMaps?.map((map) => {
          const student = map.user;
          return {
            id: map.studentId,
            fullName: `${student.firstName} ${student.lastName}`,
            programName: response.curriculum.program?.name || "Unknown",
            startDate,
            endDate,
            numberGrade: map.numberGrade || null,
            letterGrade: map.letterGrade || null,
          };
        });

        this.currentClass = {
          name: response.curriculum.program?.name || "None Assigned",
          startDate,
          endDate,
          isIntegratedWithGoogleClassroom: false,
        };

        this.allStudents = response ? students : [];
        this.filteredStudents = response ? students : [];
      } catch (error) {
        alert(
          "An error occurred while fetching class details. Please try again later.",
        );
      }
    },
    // async getClass() {
    //   try {
    //     let response;
    //     if (this.$route.params.id) {
    //       response = await classesAPIService.getByInstructorId(
    //         this.$route.params.id,
    //       );
    //     } else {
    //       const store = useLoginStore();
    //       const user = store.getUser;
    //       response = await classesAPIService.getByInstructorUserId(user.id);
    //     }

    //     const startDate = response.startDate
    //       ? dayjs(response.startDate).format("MM/DD/YYYY")
    //       : "";
    //     const endDate = response.endDate
    //       ? dayjs(response.endDate).format("MM/DD/YYYY")
    //       : "";

    //     const students = response?.studentToClassMaps?.map((map) => {
    //       const student = map.user;
    //       return {
    //         id: map.studentId,
    //         fullName: `${student.firstName} ${student.lastName}`,
    //         programName: response.curriculum.program?.name || "Unknown",
    //         startDate,
    //         endDate,
    //         numberGrade: map.numberGrade || null,
    //         letterGrade: map.letterGrade || null,
    //       };
    //     });

    //     this.currentClass = {
    //       name: response.curriculum.program?.name || "None Assigned",
    //       startDate,
    //       endDate,
    //       isIntegratedWithGoogleClassroom: false,
    //     };

    //     this.allStudents = response ? students : [];
    //     this.filteredStudents = response ? students : [];

    //     this.filteredStudents = this.filteredStudents.map((student) => ({
    //       ...student,
    //       numberGrade: student.numberGrade || null,
    //       letterGrade: student.letterGrade || null,
    //     }));
    //   } catch (error) {
    //   }
    // },
    async fetchFlightSchoolName(flightSchoolId) {
      try {
        const response = await flightSchoolsAPIService.getAllFlightSchools(
          this.$router,
        );
        const flightSchool = response.find(
          (school) => school.id === flightSchoolId,
        );
        return flightSchool ? flightSchool.name : "Unknown Flight School";
      } catch (error) {
        return "Unknown Flight School";
      }
    },

    async fetchAndCalculateAverage() {
      try {
        const grades = [];

        for (const student of this.allStudents) {
          const response =
            await activeStudentsAPIService.getStudentGradeDetails(
              student.id,
              this.$router,
            );
          if (response && response.grade) {
            grades.push(response.grade);
          }
        }

        if (grades.length > 0) {
          const total = grades.reduce((sum, grade) => sum + grade, 0);
          this.averageGrade = (total / grades.length).toFixed(2);
        } else {
          this.averageGrade = 0;
        }
      } catch (error) {}
    },

    async fetchStudents() {
      try {
        // Fetch all students for the instructor
        const response =
          await activeStudentsAPIService.getStudentsByInstructorUserId(
            this.getId(),
            this.$router,
          );
        // if (!response || !Array.isArray(response)) {
        //   throw new Error("Invalid response from server");
        // }
        this.allStudents = response;

        // Fetch grade details for each student
        const updatedStudents = await Promise.all(
          this.allStudents.map(async (student) => {
            try {
              // Use getStudentGradeDetails to fetch grades
              const gradeResponse =
                await activeStudentsAPIService.getStudentGradeDetails(
                  student.id,
                  this.$router,
                );
              return {
                ...student,
                numberGrade: gradeResponse?.grade || null,
                letterGrade: gradeResponse?.letterGrade || null,
              };
            } catch (error) {
              return {
                ...student,
                numberGrade: null,
                letterGrade: null,
              };
            }
          }),
        );

        // Update the filtered students list
        this.filteredStudents = updatedStudents;
      } catch (error) {}
    },
    // Utility Methods
    formatPhoneNumber(phoneNumber) {
      if (!phoneNumber) return "";
      const cleaned = ("" + phoneNumber).replace(/\D/g, "");
      const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
      return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phoneNumber;
    },
    async getInstructor() {
      let response;
      try {
        if (this.$route.params.id) {
          response = await activeInstructorsAPIService.getInstructorById(
            this.$route.params.id,
          );
        } else {
          const store = useLoginStore();
          const user = store.getUser;
          response = await activeInstructorsAPIService.getInstructorByUserId(
            user.id,
          );
        }

        const flightSchoolName = await this.fetchFlightSchoolName(
          response.user.flightSchoolId,
        );

        const roles = await activeInstructorsAPIService.getInstructorRoles();
        const roleName = roles.find(
          (role) => role.id === response.instructorRoleId,
        )?.name;
        const certAcronyms =
          response.user.userProgramCerts?.map((cert) => cert.program.acronym) ||
          [];

        this.instructor = {
          ...response,
          lastName: response.user.lastName,
          firstName: response.user.firstName,
          email: response.user.email,
          phone: response.user.phone,
          role: roleName || "No Role Assigned",
          certs: certAcronyms.join(", "),
          lastSessionId: 7,
          balance: 500,
          flightSchool: flightSchoolName,
        };
      } catch (error) {}
      this.getProfilePic();
    },

    // Utility Methods
    getId() {
      const store = useLoginStore();
      const user = store.getUser;
      return this.$route.params.id ? this.$route.params.id : user.id;
    },

    getProfilePic() {
      const apiUrl = process.env.VUE_APP_API_URL;
      this.profilePicPath = this.instructor?.user?.image
        ? `${apiUrl}/file_uploads/${this.instructor.user.image.split("/").pop()}`
        : "/static/img/faces/face-0.jpg";
    },

    // Table Setup
    setupTableColumns() {
      this.hiloTableColumns = [
        {
          key: "fullName",
          label: "Student",
        },
        {
          key: "startDate",
          label: "Start Date",
          value: (row) =>
            row.startDate ? dayjs(row.startDate).format("MM/DD/YYYY") : "-",
        },
        {
          key: "endDate",
          label: "End Date",
          value: (row) =>
            row.endDate ? dayjs(row.endDate).format("MM/DD/YYYY") : "-",
        },
        {
          key: "programName",
          label: "Program",
        },
        {
          key: "grade",
          label: "Grade",
          value: (row) =>
            `${row.numberGrade || "-"}% | ${row.letterGrade || "-"}`,
        },
        {
          key: "percentage",
          label: "Percentage",
          value: (row) => `${row.numberGrade || "-"}%`,
        },
        {
          key: "profile",
          label: null,
          isHtml: true,
        },
      ];

      this.filteredStudents = this.filteredStudents.map((student) => ({
        ...student,
        profile: `<a href="javascript:void(0)" class="cursor-pointer" onclick="window.navigateToStudentProfile(${student.id})">View Student</a>`,
      }));

      window.navigateToStudentProfile = this.navigateToStudentProfile;
    },

    getPayroll() {
      this.payroll = {
        paymentDate: new Date("04/20/2024"),
        amount: 1200,
        periodStart: new Date("04/01/2024"),
        periodEnd: new Date("04/15/2024"),
      };
    },

    calculateDaysLeft() {
      const today = dayjs();
      const endDate = dayjs(this.currentClass.endDate);
      return endDate.diff(today, "day");
    },
  },
};
</script>

<style lang="scss" scoped>
p {
  font-size: 15px;
}

span {
  font-size: 25px;
  color: #404040;
  line-height: normal;
}

.border-info::after {
  content: "";
  margin: 0 10px;
  border-right: 1px solid rgba(64, 64, 64, 0.5);
  height: 100%;
}

h3 {
  font-size: 40px;
  margin: 0;
  line-height: 1em;
}

h4,
span {
  font-size: 30px;
}

.buttons {
  gap: 10px;

  .btn {
    background-color: rgba(64, 64, 64, 0.5);
    color: #fff;
    width: 200px;
    max-width: 100%;
    height: 27px;
    font-size: 15px;
    padding: 0 20px;
    transition: background-color 0.3s ease;

    &:hover {
      background-color: #404040;
    }
  }

  .btn-green {
    background-color: #28a745;
  }
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;

  .profile-card {
    width: calc(33.33% - 16px);
    min-width: 426px;
    padding: 15px;
    margin: 0 50px 20px 0;
    border-radius: 15px;
    background: #fff;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);

    .dots {
      transform: rotate(-90deg);
    }

    .role {
      font-size: 40px;
      color: #404040;
      font-weight: 700;
    }

    .grade-banner {
      border-radius: 5px;
      height: 27px;
      color: #fff;
      font-size: 15px;
      padding: 0px 10px;
      display: flex;
      align-items: center;
      line-height: 0;
    }

    .grade {
      font-weight: 700;
      font-size: 40px;
    }

    .average-grade {
      font-size: 40px;
      font-weight: 700;
    }

    .progress {
      border-radius: 100px;
      height: 15px;
      margin-bottom: 0;

      .progress-bar {
        border-radius: 100px;
        background-color: #00a551;
      }

      p {
        font-size: 10px;
        color: #fff;
      }
    }

    .btn {
      width: 100%;
      color: #404040;
      background-color: rgba(64, 64, 64, 0.25);
      padding: 0 5px;

      &:hover {
        background-color: #404040;
        color: #fff;
      }
    }
  }

  .payroll {
    background: #00a551;
    color: #fff;
    text-align: center;
    height: 100px;
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: center;

    span {
      font-weight: 700;
      color: #fff;
    }
  }

  .hours-card {
    h4,
    p {
      text-align: center;
    }
  }
}

.instructor-card {
  display: flex;
  align-items: center;

  img {
    border-radius: 10px;
    object-fit: cover;
    margin-right: 50px;
  }

  .instructor-info {
    flex-grow: 1;

    .instructor-name {
      font-size: 60px;
      color: #404040;
      font-weight: 800;
      line-height: 1em;
    }

    span {
      font-size: 25px;
    }
  }
}

.schedule {
  .schedule-container-class {
    .schedule-card-class {
      min-width: 140px !important;
    }
  }

  h1 {
    font-size: 60px;
    font-weight: 700;
    padding-right: 30px;
    color: #404040;
  }
}

::v-deep(.hilo-table-container) {
  border-radius: 15px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.15);

  .hilo-table {
    background: #fff;

    th {
      background: rgba(64, 64, 64, 0.75);
      color: #fff;
    }

    td {
      border-right: 0.25px solid rgba(64, 64, 64, 0.5);
      border-bottom: 0.5px solid rgba(64, 64, 64, 0.5);
      border-left: 0.5px solid rgba(64, 64, 64, 0.5);
      min-width: 130px;

      a {
        color: #404040;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

// Responsive Design
@media (max-width: 1024px) {
  .profile-card {
    flex: 1 1 calc(50% - 50px);
    max-width: calc(50% - 50px);
  }
}

@media (max-width: 768px) {
  .profile-card {
    flex: 1 1 100%;
    max-width: 100%;
  }
}
</style>
